<template>
    <div>
        <div v-if="name === 'uniqueItems'">
            <unique-items
                :requirement="requirement"
                :packages="packages"
                :deals="deals"
                :products="products"
            />
        </div>

        <div v-if="name === 'minimumOrderTotal'">
            <minimum-order-total :requirement="requirement" />
        </div>
    </div>
</template>

<script>
import uniqueItems from './uniqueItems';
import minimumOrderTotal from './minimumOrderTotal';

export default {
    props: {
        name: String,
        requirement: Object,
        packages: Array,
        deals: Array,
        products: Array
    },
    components: {
        'unique-items': uniqueItems,
        'minimum-order-total': minimumOrderTotal,
    }
}
</script>